<script src="../app.routing.ts"></script>
<div class="" [class.hidden]="preLoader"
    style="width: 100%;text-align: center;height: 100%;position: fixed;padding-top: 40vh;z-index: 9999;background: rgba(255, 255, 255, 0.94);">
    <img class="animated infinite pulse" src="images_ext/logo1.png" style="width: 125px;">
</div>

<div class="menubar-hoverable header-fixed menubar-pin "
    style="font-family: 'Roboto', sans-serif, Helvetica, Arial, sans-serif;font-size: 13px;line-height: 1.846153846;color: #313534;background-color: #ffffff;">
    <!-- header -->
    <!--  -->

    <!-- School Details Popup -->
    <div *ngIf="schoolDetailView" class="school-card-canvus">
        <div class="school-card">
            <div class="col-md-12 schoolTitle">
                <img class="sclImg" src="{{sImage}}" height="70" width="70">
                <h2>{{sName}}</h2>
            </div>
            <div class="col-md-12 schoolData">
                <div class="col-md-3 sub-data">
                    <p>Total Students</p>
                    <p class="school-name">{{sStudent}}</p>
                </div>
                <div class="col-md-3 sub-data">
                    <p>Total Staffs</p>
                    <p class="school-name">{{sStaff}}</p>
                </div>
                <div class="col-md-3 sub-data">
                    <p>Fees Collected</p>
                    <p class="school-name">{{numberToCurrency(sCollected)}}</p>
                </div>
                <div class="col-md-3 sub-data">
                    <p>Resource Fees</p>
                    <p class="school-name">{{numberToCurrency(sResource)}}</p>
                </div>
            </div>
            <div class="col-md-12 schoolBtn">
                <button class="btnClose" (click)="closeSchoolDetails()">Close</button>
                <button *ngIf="sIsSuspended == 0" class="btnDetails" (click)="visitSchool(sDomain,sId)">Login</button>
            </div>
        </div>
    </div>
    <!-- End School Details Popup -->

    <!-- BEGIN BASE-->
    <div id="base">
        <div class="hide" id="load_new_admissions"></div>
        <!-- BEGIN OFFCANVAS LEFT -->
        <div class="offcanvas">
        </div>
        <!--end .offcanvas-->
        <!-- END OFFCANVAS LEFT -->

        <!-- BEGIN CONTENT-->
        <div id="content">
            <section>
                <div class="section-body">



                    <div class="whole-box4">

                        <div class="col-md-12 content-div" >

                            <div class="col-md-12 school-heading-div">
                                <span class="school-name">Branches</span>
                                <div class="btn-group toggle-button" data-toggle="buttons">
                                    <label (click)="toggleView('card')"
                                        style="font-size: 23px;"
                                        class="btn ink-reaction switch-btn active">
                                        <input type="radio" name="options">
                                        <i class="fa fa-th-large"></i>
                                    </label>

                                    <label (click)="toggleView('list')"
                                        style="font-size: 23px;"
                                        class="btn ink-reaction switch-btn">
                                        <input type="radio" name="options">
                                        <i class="fa fa-th-list"></i>
                                    </label>
                                </div>
                            </div>

                            <div class="col-md-12 school-list">

                                <div *ngIf="getSchoolListArray.length == 0" class="col-md-12"
                                    style="text-align: center;background: url('../../assets/img/noresult.jpg');background-size: contain;background-position: -10px 4px;color: #909090;">
                                    <div class="col-md-12" style="min-height: 300px;padding-top: 4em;">
                                        <h1 style="font-size: 4em;"><i class="fa fa-institution"></i></h1>
                                        <h3>No Results</h3>
                                    </div>
                                </div>

                                <!-- card view start -->
                                <div *ngIf="schoolCardView" class="col-md-12 whole-card-container" style="padding: 0px;">
                                    <div id="card-view" *ngFor="let school of getSchoolListArray" class="col-md-4 school-cards">
                                        <div class="card-heads {{school.isSuspended == 1 ? 'school-suspended' : ''}}">
                                            <img class="cards-img" src="{{school.schoolImage}}" >
                                            <span class="cards-title">{{school.schoolName}}</span>
                                            <span *ngIf="school.isSuspended == 0" style="float: right;"><button class="cards-btn" (click)="schoolDetails(school.schoolId,school.SchoolDomain,school.schoolImage,school.schoolName,school.totalStudent,school.totalStaff,school.totalCollectedFees,school.resourceFee,school.isSuspended)">
                                                View More</button>
                                            </span>
                                        </div>
                                        <div class="col-md-12 cards-body">
                                            <div class="col-md-4 sub-cards">
                                                <p class="sub-cards-title">Total Students</p>
                                                <p class="sub-cards-value">{{school.totalStudent}}</p>
                                            </div>
                                            <div class="col-md-4 sub-cards">
                                                <p class="sub-cards-title">Total Staffs</p>
                                                <p class="sub-cards-value">{{school.totalStaff}}</p>
                                            </div>
                                            <div class="col-md-4 sub-cards">
                                                <p class="sub-cards-title">Fees Collected</p>
                                                <p class="sub-cards-value">{{numberToCurrency(school.totalCollectedFees)}}</p>
                                            </div>
                                            
                                        </div>
                                        <div class="school-domain-url">
                                            <span>Access URL: </span><a href="{{getTheDomainName(school.SchoolDomain)}}" target="_blank">{{getTheDomainName(school.SchoolDomain)}}</a>
                                        </div>
                                    </div>
                                </div>
                                <!-- card view end -->
                                
                                <!-- table view start -->
                                <div *ngIf="schoolListView" class="table-responsive">
                                    <table id="new-admission-table" class="display" cellspacing="0" width="100%">
                                        <thead class="table-head">
                                            <tr>
                                                <th class="table-headings"></th>
                                                <th class="table-headings">School Name</th>
                                                <th class="table-headings"></th>
                                                <th class="table-headings">Total Students</th>
                                                <th class="table-headings">Total Staffs</th>
                                                <th class="table-headings">Fees Collected</th>
                                                <th class="table-headings">Resource Fees</th>
                                                <th class="table-headings"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let school of getSchoolListArray" class="gradeX {{school.isSuspended == 1 ? 'school-suspended' : ''}}">
                                                <th class="table-data">
                                                    <img class="school-image" src="{{school.schoolImage}}">
                                                </th>
                                                <th class="table-data">{{school.schoolName}}</th>
                                                <th *ngIf="school.accountType == 'Premium'">
                                                    <div class="school-account-pro">Pro</div>
                                                </th>
                                                <th *ngIf="school.accountType == 'Trial'">
                                                    <div class="school-account-trial">Trial</div>
                                                </th>
                                                <th class="table-data">{{school.totalStudent}}</th>
                                                <th class="table-data">{{school.totalStaff}}</th>
                                                <th class="table-data">{{numberToCurrency(school.totalCollectedFees)}}</th>
                                                <th class="table-data">{{numberToCurrency(school.resourceFee)}}</th>
                                                <th class="table-data">
                                                    <button *ngIf="school.isSuspended == 0" class="view-more-btn"
                                                        (click)="schoolDetails(school.schoolId,school.SchoolDomain,school.schoolImage,school.schoolName,school.totalStudent,school.totalStaff,school.totalCollectedFees,school.resourceFee,school.isSuspended)">
                                                        View More
                                                    </button>
                                                    <span *ngIf="school.isSuspended == 1">Suspended</span>
                                                </th>
                                            </tr>


                                        </tbody>
                                    </table>
                                </div>
                                <!-- table view end -->

                            </div>
                        </div>

                    </div>

                </div>
                <!--end .section-body -->
            </section>
        </div>
        <!--end #content-->
        <!-- END CONTENT -->

        <!-- Menubar -->
        <!--  -->

    </div>
    <!--end #base-->
    <!-- END BASE -->
</div>